import { render, staticRenderFns } from "./RiasecDiagnostics.vue?vue&type=template&id=5946f7ca&scoped=true&"
import script from "./RiasecDiagnostics.vue?vue&type=script&lang=js&"
export * from "./RiasecDiagnostics.vue?vue&type=script&lang=js&"
import style0 from "./RiasecDiagnostics.vue?vue&type=style&index=0&id=5946f7ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5946f7ca",
  null
  
)

export default component.exports